import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/food/hero-background-1.25x.jpg?url';

export default {
  lqip: `data:image/jpeg;base64,UklGRrQAAABXRUJQVlA4IKgAAABwBQCdASogABEAPm0ukkWkIqGYBABABsSgCuS5RARgJV5T2dCc3Vb0X3Igi/GK/N0QNhSoAP7XhVfbNkFdDmO7d1x2F0HrLw5657Tbxnu5Gfu5kkUMidUNahEhZtfo+8yp5cjHbq46B4O1iY2Rhsc3E9+mjHhu9Ox50iaAC156+jGJ50iHAeKXFtksoZa56XhaQ/+GG+kaZ3OnjUcEIC2Ki+c8l82gAAA=`,
  src,
  width: 1800,
  height: 958,
};
			